import React, { useEffect, useState } from "react";
import { Row, Col, Form, Input } from 'antd';
import konsole from "../network/konsole";
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';

const { TextArea } = Input;

const AddEditSpeakerModal = ({ setGetFName, setGetLName, setGetEmail, setGetContact, getCoordName, setcountrycode, form, coordinatorspeakertype }) => {

    const [firstNames, setFirstNames] = useState("")
    const [lastName, setLastName] = useState("")
    const [email, setEmail] = useState("")
    const [mobileNumber, setMobileNumber] = useState("")
    const [codeMobileNo, setCodeMobileNo] = useState("+1")
    const [selectedCountry, setSelectedCountry] = useState("us")
    const [linkrequired,setLinkrequired]=useState(true)
    useEffect(()=>{
if(coordinatorspeakertype !==undefined && coordinatorspeakertype=='Coordinator' ){
    setLinkrequired(false)

}
    },[])
    const onChangePhone = (value, country) => {
        const dialCode = country?.dialCode || "1";
        setCodeMobileNo("+" + dialCode);
        setSelectedCountry(country?.countryCode || "us");
        setMobileNumber(value);
        setGetContact(value);
        setcountrycode("+" + dialCode);
        form.setFieldsValue({ PhoneNumber: value });
    };

    setGetFName(firstNames)
    setGetLName(lastName)
    setGetEmail(email)

    konsole.log("CoordinatorName", getCoordName)

    useEffect(() => {
        let splitGetCoordName = getCoordName.split(" ")
        konsole.log("splitGetCoordName", splitGetCoordName)

        // konsole.log("MySended", getCoordName)
        form.setFieldsValue({
            "firstName": splitGetCoordName[0],
            // "lastname": splitGetCoordName[1].charAt(0).toUpperCase() + splitGetCoordName[1].slice(1)
        })
        if(splitGetCoordName?.length ==2){
            form.setFieldsValue({
                "lastname": splitGetCoordName[1].charAt(0).toUpperCase() + splitGetCoordName[1].slice(1)
                ,      });
      
          }


        let GetFieldFirstName = form.getFieldValue("firstName")
        konsole.log("GetFieldFirstName", GetFieldFirstName);
        setFirstNames(GetFieldFirstName)

        let getFieldLastName = form.getFieldValue("lastname")
        setLastName(getFieldLastName)

    }, [getCoordName])

    return (
        <>



            <Row className='w-100' gutter={[8, 8]}>
                <Col xs={24} lg={24}>
                    <Form.Item
                        label="First Name"
                        name="firstName"
                        rules={[
                            {pattern: new RegExp(/^[a-zA-Z]*$/),message: "No Space or Special Characters Allowed"},
                            { required: true, message: 'Please input your first Name!' }]}

                    >

                        <Input  onInput={e => e.target.value = e.target.value.charAt(0).toUpperCase() + e.target.value.slice(1)}/>
                    </Form.Item>
                </Col>
                <Col xs={24} lg={24}>
                    <Form.Item
                        label="Last Name"
                        name="lastname"
                        rules={[
                            {pattern: new RegExp(/^[a-zA-Z]*$/),message: "No Space or Special Characters Allowed"},
                            { required: true, message: 'Please input your last name!' }]}
                    >

                        <Input  onInput={e => e.target.value = e.target.value.charAt(0).toUpperCase() + e.target.value.slice(1)}/>

                    </Form.Item>
                </Col>

                <Col xs={24} lg={24}>
                    <Form.Item
                        label="Profile"
                        name="Profile"
                        rules={[
                            { message: 'Please enter your Profile Details' }]}
                    >
                        
                        <TextArea rows={2}  onInput={e => e.target.value = e.target.value.charAt(0).toUpperCase() + e.target.value.slice(1)}/>
                    </Form.Item>

                </Col>


                <Col xs={24} lg={24}>

                    <Form.Item
                        name="Video Link"
                        label=" Link"
                        rules={[
                            {pattern: new RegExp('https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|http?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s]{2,}|www\.[a-zA-Z0-9]+\.[^\s]{2,}')
                            , message: 'Please enter correct url format!'},
                            { required: linkrequired, message: 'Please input link!' }
                
                          ]}
                    >
                        <Input placeholder="https://" />
                    </Form.Item>

                </Col>
                <Col xs={24} lg={24}>
                    <Form.Item
                        name="email"
                        label="E-mail"

                        rules={[
                            {pattern: new RegExp("[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,3}$"),message: "Please enter correct email address"},
                            {
                              required: true,
                              message: 'Please input your E-mail!',
                            },
                          ]}
                    >
                        <Input onChange={(e) => setEmail(e.target.value)} />
                    </Form.Item>
                </Col>

                <Col xs={24} lg={24}>
                    <Form.Item
                        name="phone"
                        label="Cell Number"
                    >
                        <PhoneInput
                            country={selectedCountry}
                            preferredCountries={["us"]}
                            value={mobileNumber}
                            onChange={onChangePhone}
                            countryCodeEditable={false}
                            disableCountryGuess={true}
                            inputStyle={{ width: "100%", height: "44px" }}
                            containerStyle={{ width: "100%" }}
                        />
                    </Form.Item>
                </Col>

            </Row>

        </>
    )
}

export default AddEditSpeakerModal;